// src/features/dashboard/components/ActivityTimeline.tsx
import {
  UserRoundPlus,
  WalletMinimal,
  ShieldCheck,
  MessageCircleReply,
  PackageCheck,
  RefreshCw,
} from 'lucide-react';
import { GlassCard } from '../../../app/components/ui/GlassCard';
import { ListItemSkeleton } from './ui/Skeleton';
import type { TimelineEvent, TimelineEventKind } from '../types/dashboard.types';

interface ActivityTimelineProps {
  events: TimelineEvent[];
  isInitialLoading: boolean;
}

const ICON_MAP: Record<TimelineEventKind, typeof UserRoundPlus> = {
  'customer-registered': UserRoundPlus,
  'wallet-charged': WalletMinimal,
  'service-activated': ShieldCheck,
  'ticket-answered': MessageCircleReply,
  'order-completed': PackageCheck,
  'service-renewed': RefreshCw,
};

const ACCENT_MAP: Record<TimelineEventKind, string> = {
  'customer-registered': 'violet',
  'wallet-charged': 'amber',
  'service-activated': 'teal',
  'ticket-answered': 'sky',
  'order-completed': 'teal',
  'service-renewed': 'indigo',
};

export function ActivityTimeline({ events, isInitialLoading }: ActivityTimelineProps) {
  return (
    <GlassCard data-animate="fade-in">
      <div className="vania-panel-header">
        <h3 className="vania-panel-title">فعالیت‌های اخیر</h3>
        {!isInitialLoading && <span className="vania-panel-count">{events.length}</span>}
      </div>

      {isInitialLoading ? (
        <div className="flex flex-col">
          {Array.from({ length: 5 }).map((_, i) => (
            <ListItemSkeleton key={i} />
          ))}
        </div>
      ) : (
        <ol className="vania-timeline">
          {events.map((event) => {
            const Icon = ICON_MAP[event.kind];
            const accent = ACCENT_MAP[event.kind];
            return (
              <li key={event.id} className="vania-timeline-item">
                <span className={`vania-icon-badge vania-icon-badge--${accent} vania-timeline-icon`}>
                  <Icon size={15} strokeWidth={2.2} />
                </span>
                <div className="flex-1 min-w-0 pb-5">
                  <div className="flex items-center justify-between gap-2">
                    <span className="text-sm font-medium text-[var(--vania-text-primary,#f5f6fa)]">
                      {event.title}
                    </span>
                    <span className="text-[11px] text-[var(--vania-text-tertiary,#6b7280)] shrink-0">
                      {event.time}
                    </span>
                  </div>
                  <p className="text-xs text-[var(--vania-text-secondary,#a3aab8)] mt-0.5">
                    {event.description}
                  </p>
                </div>
              </li>
            );
          })}
        </ol>
      )}
    </GlassCard>
  );
}
